import { Alert, AlertDescription, AlertIcon, BoxProps, Button } from "@chakra-ui/react";
import { useDeepAuth } from "components/api";
import { NYIL_BTN } from "theme";
import { TProtectionLevel } from "./DeepAuth";



export interface AuthWarningBoxProps extends BoxProps {
	protLev?: TProtectionLevel;
}

export function AuthWarningBox({ protLev = 'confirmed' }: AuthWarningBoxProps) {
	const auth = useDeepAuth();
	const protFailed = auth.protectionFailed(protLev);
	if (!protFailed)
		return <></>;



	return <Alert status="warning">
		<AlertIcon />
		<AlertDescription>
			{protFailed === 'not_confirmed' && <>
				Még nem erősítetted meg az email címedet, így ezt a funkciót nem használhatod! 
				<Button onClick={() => auth.showSignIn()} size='sm' colorScheme="yellow" variant='ghost' >{NYIL_BTN}&nbsp;Tovább a bejelentkezéshez</Button>
			</>} 
			{protFailed === 'not_logged_in' && <>
				Nem jelentkeztél be, így ezt a funkciót nem használhatod!<br/>
				<Button onClick={() => auth.showSignIn} >Bejelentkezés</Button>
			</>} 
		</AlertDescription>
	</Alert>

}